// extracted by mini-css-extract-plugin
export default {"noValueAllowed":"noValueAllowed---Zo3c4","iconContainer":"iconContainer---pjUYS"};